import React from 'react';
import SearchFilter from './SearchFilter';
import SelectFilter from './SelectFilter';
import CustomFilter from './CustomFilter';

// type = 'select' | 'search'

const Filter = ({
  type = 'select',
  name,
  multiple,
  items,
  loading,
  errorMessage,
  refetch,
  placeholder,
  renderContent,
}) => {
  if (typeof renderContent === 'function') {
    return <CustomFilter name={name} renderContent={renderContent} />;
  }

  if (type === 'search') {
    return <SearchFilter name={name} placeholder={placeholder} />;
  }

  return (
    <SelectFilter
      name={name}
      multiple={multiple}
      items={items}
      loading={loading}
      errorMessage={errorMessage}
      refetch={refetch}
    />
  );
};

export default Filter;
